import { useEffect, useState } from "react";
import BlogHero from "./BlogHero";
import BlogCard from "./BlogCard";
import BlogModal from "./BlogModal";
import { BLOGS } from "./blog.data";

const BlogPage: React.FC = () => {
  const [selectedBlog, setSelectedBlog] = useState<any>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="relative w-full overflow-hidden bg-bg-primary text-text-primary">

      {/* Medical textured background (same as other pages) */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-medical-texture opacity-[0.35]"
      />

      {/* Page container */}
      <div
        className="
          relative mx-auto max-w-[1440px]
          px-4 sm:px-6 lg:px-12
          pt-20 sm:pt-24 lg:pt-32
          pb-20 sm:pb-24 lg:pb-32
        "
      >
        {/* Controlled internal spacing */}
        <div className="space-y-12 sm:space-y-16 lg:space-y-20">
          <BlogHero />

          <section className="max-w-7xl mx-auto grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {BLOGS.map((blog) => (
              <BlogCard
                key={blog.id}
                blog={blog}
                onClick={() => setSelectedBlog(blog)}
              />
            ))}
          </section>
        </div>
      </div>

      {selectedBlog && (
        <BlogModal
          blog={selectedBlog}
          onClose={() => setSelectedBlog(null)}
        />
      )}
    </main>
  );
};

export default BlogPage;
